// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
// import Swiper from "../../node_modules/swiper/js/swiper";

// import the latest version
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  Scrollbar,
  Thumbs,
} from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs]);

/*
 *
 * ----------------------------------------------- */
var swiperFv = document.querySelector(".swiper-fv");

if (swiperFv) {
  new Swiper(swiperFv, {
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    speed: 1500,
    loopedSlides: 20,
    loop: true,
    spaceBetween: 13,

    breakpoints: {
      768: {
        spaceBetween: 55,
      },
    },
  });
}

/*
 *
 * ----------------------------------------------- */
var swiperCase = document.querySelector(".swiper-case");

if (swiperCase) {
  new Swiper(swiperCase, {
    slidesPerView: "auto",
    speed: 1500,
    spaceBetween: 30,

    breakpoints: {
      768: {
        spaceBetween: 50,

        scrollbar: {
          dragSize: 190,
        },
      },
    },

    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      dragSize: 112,
    },
  });
}

/*
 *
 * ----------------------------------------------- */
var swiperCaseDetail = document.querySelector(".swiper-case-detail");
var swiperCaseDetailThumbnail = document.querySelector(
  ".swiper-case-detail-thumbnail"
);

if (swiperCaseDetail && swiperCaseDetailThumbnail) {
  var swiperMain = new Swiper(swiperCaseDetailThumbnail, {
    loop: true,
    spaceBetween: 7,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-thumbnail-next",
      prevEl: ".swiper-button-thumbnail-prev",
    },
    breakpoints: {
      768: {
        spaceBetween: 25,
      },
    },
  });

  new Swiper(swiperCaseDetail, {
    loop: true,
    spaceBetween: 10,
    thumbs: {
      swiper: swiperMain,
    },
  });
}
